var _path, _path2, _path3, _path4, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2103_20)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2103_20",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2103_20)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M4.49979 -0.000910406C4.36726 -0.000820035 4.24019 0.0518483 4.14648 0.145528C4.05278 0.239207 4.00009 0.366237 4 0.498719V31.4986C4.00009 31.6311 4.05278 31.7581 4.14648 31.8518C4.24019 31.9455 4.36726 31.9981 4.49979 31.9982H28.2759C28.4085 31.9981 28.5355 31.9455 28.6293 31.8518C28.723 31.7581 28.7756 31.6311 28.7757 31.4986V10.148C28.7765 10.0171 28.7258 9.89114 28.6346 9.79717L19.2645 0.193602V0.189794C19.2525 0.176404 19.2397 0.163672 19.2264 0.151655C19.2131 0.138158 19.1991 0.125425 19.1844 0.113516C19.1698 0.101209 19.1545 0.0897489 19.1386 0.0791903C19.1238 0.069488 19.1085 0.0605759 19.0928 0.0524921C19.084 0.04842 19.0751 0.0446038 19.0661 0.0410488C19.0499 0.0338151 19.0334 0.0274468 19.0165 0.0219706C19.0077 0.0191788 18.9988 0.0166326 18.9898 0.0143352H18.9783C18.9544 0.00875115 18.9302 0.00492678 18.9058 0.00289238C18.8969 0.00138331 18.888 0.000113518 18.8791 -0.000915527H18.8676H18.8523L4.49979 -0.000910406ZM4.99958 0.998349H18.6541L27.7762 10.3502V30.999H4.99958V0.998349Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M18.8527 -0.00077963C18.7228 0.00327213 18.5996 0.057684 18.5092 0.150938C18.4188 0.244191 18.3682 0.368967 18.3682 0.49885V10.1482C18.3683 10.2807 18.4209 10.4077 18.5146 10.5014C18.6084 10.5951 18.7354 10.6477 18.868 10.6478H28.2762C28.3749 10.6482 28.4715 10.6194 28.5539 10.565C28.6363 10.5106 28.7007 10.433 28.7391 10.342C28.7774 10.2511 28.788 10.1508 28.7694 10.0539C28.7509 9.95696 28.704 9.86767 28.6348 9.7973L19.2266 0.151779C19.1783 0.101764 19.1201 0.0623649 19.0557 0.0360969C18.9913 0.00982897 18.9222 -0.00273034 18.8527 -0.00077963ZM19.3677 1.73076L27.0935 9.64855H19.3677V1.73076Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2103_20",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 14,
    width: 9,
    height: 9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14H12V23H21V14Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2103_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.875 19.625V21.125C19.875 21.3239 19.796 21.5147 19.6553 21.6553C19.5147 21.796 19.3239 21.875 19.125 21.875H13.875C13.6761 21.875 13.4853 21.796 13.3447 21.6553C13.204 21.5147 13.125 21.3239 13.125 21.125V19.625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 17.75L16.5 19.625L18.375 17.75",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 17.75L16.5 19.625L18.375 17.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.625V15.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.625V15.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2103_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportFile);
export default __webpack_public_path__ + "static/media/export-file.e65bb2aae0101c1cea14269911fe09a5.svg";
export { ForwardRef as ReactComponent };